import React from 'react';
import Form from 'react-bootstrap/Form';
import PropTypes from 'prop-types';
import { splitCamelCaseToString } from '~/utils/helpers';

function SelectionBox({ setSelectedReport, reports }) {
    return (
        <div className="d-flex justify-content-center">
            <Form>
                <Form.Control
                    as="select"
                    onChange={(e) => setSelectedReport(e.target.value)}
                >
                    <option disabled>Select...</option>
                    {reports.map((item) => (
                        <option
                            value={item}
                            key={item}
                        >
                            {splitCamelCaseToString(item).includes('Character Class') ? 'Character Class Pick Ratio' : splitCamelCaseToString(item)}
                        </option>
                    ))}
                </Form.Control>
            </Form>
        </div>
    );
}

export default SelectionBox;

SelectionBox.propTypes = {
    setSelectedReport: PropTypes.func.isRequired,
    reports: PropTypes.array.isRequired,
};
